import { useState, useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
import { cn } from '@divlab/divanui';

import AboutReceiptButton from '@Components/AboutReceiptButton';
import styles from './SaleSoonButton.module.css';

import type { ProductData } from '@Types/Product';
import type { FC } from 'react';

interface SaleSoonButtonProps {
  product: ProductData;
  className?: string;
  visible?: boolean;
}

const SaleSoonButton: FC<SaleSoonButtonProps> = (props) => {
  const { visible, product, className } = props;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(visible);
  }, [visible]);

  return (
    <CSSTransition
      timeout={400}
      classNames={{
        enter: styles.enter,
        enterActive: styles.enterActive,
        enterDone: styles.enterDone,
        exit: styles.exit,
        exitActive: styles.exitActive,
        exitDone: styles.exitDone,
      }}
      unmountOnExit
      in={open}
    >
      <div className={cn(styles.inner, className)}>
        <AboutReceiptButton className={styles.button} product={product} />
      </div>
    </CSSTransition>
  );
};

export default SaleSoonButton;
